import { useState } from "react";
import { Play } from "lucide-react";

export const VideoEmbed = ({ videoId, title, aspect = "16:9", testid }) => {
  const [playing, setPlaying] = useState(false);
  const ratio = aspect === "9:16" ? "aspect-[9/16]" : "aspect-video";

  return (
    <div
      data-testid={testid}
      className={`relative ${ratio} w-full overflow-hidden rounded-sm border border-[#C9A45C]/50 bg-black shadow-[0_4px_30px_rgba(201,164,92,0.15)]`}
    >
      {playing ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="absolute inset-0 h-full w-full"
        />
      ) : (
        <button
          data-testid={`${testid}-play-button`}
          onClick={() => setPlaying(true)}
          aria-label={`Riproduci il video: ${title}`}
          className="group absolute inset-0 h-full w-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A45C]"
        >
          <img
            src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
            alt={`Anteprima video: ${title}`}
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-70 transition-opacity duration-300 group-hover:opacity-90"
          />
          <span className="absolute inset-0 bg-black/30" aria-hidden="true" />
          <span
            className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-[#C9A45C] bg-black/60 transition-transform duration-300 group-hover:scale-110 group-hover:bg-[#C9A45C] sm:h-20 sm:w-20"
            aria-hidden="true"
          >
            <Play className="ml-1 h-7 w-7 fill-[#C9A45C] text-[#C9A45C] transition-colors duration-300 group-hover:fill-[#080808] group-hover:text-[#080808]" />
          </span>
        </button>
      )}
    </div>
  );
};
